module.exports = __webpack_public_path__ + "static/media/empty-set.7bc02049.svg";